<template>
  <iframe
    :src="src"
    id="embedded-app"
  >
    <p>Your browser does not support iframes. Please enable iframes or try using a modern browser</p>
  </iframe>
</template>
<script>
  import { iframeResizer } from 'iframe-resizer'
  import util from '../util'

  export default {
    name: 'ProtocolView',
    props: ['src'],
    mounted () {
      // initialize iframeresizer
      iframeResizer({
        log: process.env.NODE_ENV === 'development', // log only in development
        checkOrigin: false // TODO
      }, '#embedded-app')

      // handle scrollToTop messages
      util.createIframeListener('embedded-app') // TODO: move this id to constants or something
    }
  }
</script>



// WEBPACK FOOTER //
// EmbeddedApp.vue?e0c5845a